import { cacheKeys } from "@constants/cache-keys";
import { useQuery } from "@tanstack/react-query";
import { fetchProductDetails, fetchProductMetadata } from "api/queries";
import axios from "axios";
import useAppConfigIds from "./useAppConfigIds";
import { useAppStore } from "./useAppStore";
import useClerkUser from "./useClerkUser";

export const useProductDetails = () => {
	const { productId } = useAppConfigIds();
	const tenantId = useAppStore((state) => state.tenant.id);

	const { userLogicalId } = useClerkUser();

	return useQuery({
		queryKey: [cacheKeys.productDetails, productId, tenantId],
		queryFn: async () => {
			return await fetchProductDetails({
				tenantId: tenantId,
				productId: productId,
			});
		},
		enabled: !!tenantId && !!productId && !!userLogicalId,
	});
};

export const useProductMetadata = () => {
	const { productUuid } = useAppConfigIds();
	const tenantId = useAppStore((state) => state.tenant.id);

	const { userLogicalId } = useClerkUser();

	return useQuery({
		queryKey: [cacheKeys.productMetadata],
		queryFn: async () => {
			return await fetchProductMetadata({
				tenantId: tenantId,
				productId: productUuid,
				userId: userLogicalId,
			});
		},
		enabled: !!userLogicalId && !!tenantId && !!productUuid,
		retry(failureCount, error) {
			if (axios.isAxiosError(error) && !error.response) {
				return false;
			}
			return failureCount < 3;
		},
	});
};
